import React from 'react';
import CircularProgress from 'ats/components/circular-progress/CircularProgress';

export default function ApplicantStageIndicator({
	stageLabel,
	stageLevel,
	statusLabel,
	statusColor,
	size = 16,
	strokeWidth = 4,
	tooltipPosition = 'right',
	showTooltip = true
}) {
	const progress = (stageLevel / 5) * 100;
	const color = statusColor || '#6172F3';

	return (
		<CircularProgress
			size={size}
			strokeWidth={strokeWidth}
			progress={progress}
			color={color}
			tooltip={
				showTooltip ? `Stage: ${stageLabel} | Status: ${statusLabel}` : null
			}
			tooltipPosition={showTooltip ? tooltipPosition : undefined}
		/>
	);
}
